import { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { BeatLoader } from "react-spinners";
import tailwindClassnames from "./common/TailwindClassnames";

const LoginPage = () => {
  const { keycloak } = useKeycloak();

  useEffect(() => {
    if (!keycloak.authenticated) {
      keycloak.login({
        redirectUri: window.location.origin,
      });
    } else {
      window.location.href = "/";
    }
  }, [keycloak]);

  return (
    <BeatLoader
      color={tailwindClassnames.skyBlueDark}
      loading={true}
      size={15}
      margin={5}
    />
  );
};

export default LoginPage;
